import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AllGradesFilterType } from 'src/app/models/enums/allgradesFilterType';
import { Filter } from '../../interfaces/filter';

@Component({
  selector: 'app-all-grades-filters ',
  templateUrl: './all-grads-filters.component.html',
  styleUrls: ['./all-grads-filters.component.scss', './all-grads-filters.component.en.scss'],
})
export class AllGradsFiltersComponent {
  @Input({ required: true }) data: any;
  @Input({ required: true }) freeSearchPlaceholder!: string;
  @Input() searchTerm: string = '';
  @Input() disabled: boolean = false;
  @Input() isLoading: boolean = false;
  @Output() searchGrades = new EventEmitter<{ filterData: any; allGradesFilterType: AllGradesFilterType; }>();
  @Output() freeSearchChange = new EventEmitter<string>();
  allGradesFilterType = AllGradesFilterType;

  changeFilter(filterData: Filter[], allGradesFilterType: any) {
    const dataToEmit = {
      filterData: filterData,
      allGradesFilterType: allGradesFilterType,
    };
    this.searchGrades.emit(dataToEmit);
  }

  changeFreeSearch(event: any) {
    this.freeSearchChange.emit(event.target.value);
  }
}
